"use client";
import { MdIosShare, MdOutlineMobileScreenShare } from "react-icons/md";
import { BsPlusSquareFill } from "react-icons/bs";
import { useEffect, useRef, useState } from "react";
import { IoMdInformationCircleOutline, IoMdMore } from "react-icons/io";
import useDeviceDetails from "../../hooks/use-device-details";
import {
  StyledStack,
  Phelper,
  StyledMainDiv,
  StyledDescription,
  StyledTitle,
  StyledHelp,
  StyledLogoDiv,
  StyledButton,
  StyledCheckDiv,
} from "./Pwa.style";
import logo from "assets/img/Group 4 1.png";

const getDayTimestamp = (day = 3) => 1000 * 60 * 60 * 24 * day;

const checkShowAgain = () => {
  const showAgain = localStorage?.getItem("pwa-helper-show-again") ?? null;

  if (
    navigator.standalone ||
    window.matchMedia("(display-mode: standalone)").matches
  ) {
    return false;
  }

  return showAgain
    ? Boolean(new Date().getTime() - showAgain > getDayTimestamp(3))
    : true;
};
const PWAHelper = () => {
  const [isOpen, setOpen] = useState(false);
  const { isIos, isMobile } = useDeviceDetails();
  const checkRef = useRef({
    checked: false,
  });

  const handleClickButton = () => {
    setOpen(false);
    if (checkRef.current.checked) {
      localStorage.setItem("pwa-helper-show-again", new Date().getTime());
    }
  };

  useEffect(() => {
    setOpen(checkShowAgain());
  }, []);

  return isOpen && isMobile ? (
    <StyledStack>
      <div>
        <StyledLogoDiv>
          <img src={logo} />
        </StyledLogoDiv>
        <StyledTitle>آموزشگاه شریف را به صفحه اصلی اضافه کنید</StyledTitle>
        <StyledDescription>
          با اینکار دسترسی به سایت برایتان راحت تر و همیشه با آخرین بروزرسانی از
          خدمات استفاده می کنید
        </StyledDescription>
        {isIos ? (
          <StyledMainDiv>
            <Phelper>
              روی دکمه Share در نوار پایین کلیک کنید
              <MdIosShare fontSize={24} />
            </Phelper>
            <Phelper>
              روی دکمه Add to Home کلیک کنید
              <BsPlusSquareFill fontSize={22} />
            </Phelper>
            <Phelper>
              کلیک کنید Add روی دکمه
              <span>Add</span>
            </Phelper>
          </StyledMainDiv>
        ) : (
          <StyledMainDiv>
            <Phelper>
              روی دکمه More کلیک کنید
              <IoMdMore fontSize={24} />
            </Phelper>
            <Phelper>
              روی دکمه نصب برنامه کلیک کنید
              <MdOutlineMobileScreenShare fontSize={22} />
            </Phelper>
          </StyledMainDiv>
        )}

        <div>
          <StyledHelp>
            {/* <IoMdInformationCircleOutline
              fontSize={15}
              style={{ marginLeft: "10px" }}
            /> */}
            برای نصب برنامه، بهتر است مرورگر خود را بروزرسانی کنید!
          </StyledHelp>
          <StyledCheckDiv style={{ textAlign: "right" }}>
            <label htmlFor="show-again">دیگر نشان داده نشود</label>
            <input
              onChange={(val) =>
                (checkRef.current.checked = val.target.checked)
              }
              id="show-again"
              type="checkbox"
            />
          </StyledCheckDiv>
        </div>
        <StyledButton
          variant="contained"
          color="primary"
          onClick={handleClickButton}
        >
          متوجه شدم
        </StyledButton>
      </div>
    </StyledStack>
  ) : (
    ""
  );
};

export default PWAHelper;
